import Query from "./query";
import GetVolumePosition from "./getVolumePosition";
import GetModelPosition from "./getModelPosition";

class GetUserOrientation extends Query {
    constructor() {
        super("getUserOrientation");
    }

    async execute(params) {
        const orientation = iq3Camera.getConfigurationWorld().orientation;
        return orientation.toArray();
    }
}

export default GetUserOrientation;